import { ValueAxisLabels } from "@progress/kendo-angular-charts";

export class ValueAxisModel {
    name?: string;
    title?: string;
    min?: number;
    max?: number;
    majorUnit?: number;
    color?: string;
    labels?: ValueAxisLabels;
}
